import type { MainProps } from '@/components/landing-page/components/main';
import clsx from 'clsx';
import SuccessBox from '@/components/landing-page/components/success-box';
import Group from '@/components/landing-page/components/group';
import { defaults } from '@/components/landing-page/components/main';
import { ID } from '@/utils/enums';
import { cn } from '@/utils/helper';
import v1 from '@/components/landing-page/components/main/main-v1.module.css';
import v2 from '@/components/landing-page/components/main/main-v2.module.css';

const Main = (props: MainProps) => {
  const { successBox = defaults.successBox, groups = defaults.groups } = props;

  return (
    <main id={ID.LANDING_PAGE_MAIN} className={cn(v1.Main, v2.Main)}>
      <SuccessBox {...successBox} />
      {groups.length ? (
        <div className={cn(v1.Groups, v2.Groups)}>
          {groups.map((group) => (
            <Group
              key={group.id}
              group={group}
              groupClassName={clsx(cn(v1.Group, v2.Group), {
                [cn(v1.GroupTopLine, v2.GroupTopLine)]: group.showTopLine,
                [cn(v1.GroupBottomLine, v2.GroupBottomLine)]: group.showBottomLine,
              })}
              titleClassName={cn(v1.Title, v2.Title)}
              blockClassName={cn(v1.Block, v2.Block)}
            />
          ))}
        </div>
      ) : null}
    </main>
  );
};

export default Main;
